/* get dados from client */
var CLIENT_DATA_QUERYSELECTORS = {
	'nome': [
		'.newsletter-modal form input[name="name"]',
		'form input[name="pf_nome_cliente"]',
		'input#customer-name',
        'input[name="contact[name]"]'
	],
	'email': [
		'.newsletter-modal form input[name="email"]',
		'form input[name="email_cliente"]',
		'input#login-email',
		'input#customer-email',
        'input[name="contact[email]"]'
	],
	'cidade': [
		'form input[name="cidade_cliente"]',
		'input#customer-address-city'
	],
	'estado': [
		'form select#estado_cliente',
		'select#customer-address-state'
	],
	'cep': [
		'form input[name="cep"]',
		'.new-frete .box-left input.crazy_cep',
		'input#cart-shipping[name="cart-shipping"]',
		'input#customer-address-zipcode',
        'input#campoCep'
	],
	'telefone': [
		'.newsletter-modal form input[name="telefone"]',
		'form input[name="telefone_cliente_2"]',
		'input#customer-phone',
        'input[name="contact[phone]"]'
	]
};

function saveClientData(key, value){
	if(!value) return null;
    if(value.includes('*')) return null;
	var filtered_value;
	if(key === 'email' && !value.includes('@')) return null;
	if(key === 'estado' && value.length !== 2) return null;
	if(key === 'cep' || key === 'telefone'){
		filtered_value = value.replace(/\D/g,'');
	}
	if(key === 'cep' && filtered_value.length !== 8) return null;
	if(key === 'telefone' && filtered_value.length <= 8) return null;
	window.localStorage.setItem('@cliente-data-'+key, filtered_value || value);
}

function getDataFromCEP(value){
	var cep = value.replace(/\D/g,'');
	if(cep.length !== 8) return null;
	saveClientData('cep', cep);
	fetch('https://viacep.com.br/ws/' + cep + '/json/')
		.then(function(i){
			return i.json()
		})
		.then(function(data){
			if(data.cep){
				saveClientData('cidade', data.localidade);
				saveClientData('estado', data.uf);
			}
		}); 
}
  
function _observeElement(element, property, callback, delay) {
    var elementPrototype = Object.getPrototypeOf(element);
    if (elementPrototype.hasOwnProperty(property)) {
        var descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);
        Object.defineProperty(element, property, {
            get: function() {
                return descriptor.get.apply(this, arguments);
            },
            set: function () {
                var oldValue = this[property];
                descriptor.set.apply(this, arguments);
                var newValue = this[property];
                if (typeof callback == "function") {
                    setTimeout(callback.bind(this, oldValue, newValue), 0);
                }
                return newValue;
            }
        });
    }
}

function getClientDataFromInputs(){
	var keys = Object.keys(CLIENT_DATA_QUERYSELECTORS);
	keys.forEach(function(key){
		CLIENT_DATA_QUERYSELECTORS[key].forEach(function(querySelector){
			var input = document.querySelector(querySelector+':not(.saving-client-data-on-ls)');
			if(input){
				saveClientData(key, input.value);
                input.classList.add('saving-client-data-on-ls');
				input.addEventListener('keyup', function(e){
					if(key === 'cep') getDataFromCEP(e.target.value)
					saveClientData(key, e.target.value);
				});  
                _observeElement(input, "value", function (oldValue, newValue) {
                    if(key === 'cep') getDataFromCEP(newValue)
					saveClientData(key, newValue);
                });
			}
		});
	});
}
setInterval(getClientDataFromInputs, 500);

// conjuto add to cart wrapper

if (!customElements.get('custom-conjunto-form')) {
	class CustomConjuntoForm extends HTMLElement {
	  constructor() {
		super();
		this.selectedVariants = {};
		this.cartDrawer = document.querySelector('cart-drawer');
		this.init();
	  }
	  
	  init() {
		this.addBtn = this.querySelector('.conjunto-add-btn');
		this.optionsBtns = this.querySelectorAll('.conjunto-option-btn');
		this.items = this.querySelectorAll('.conjunto-item');
		
		this.optionsBtns.forEach(btn => {
		  btn.addEventListener('click', (e) => this.handleOptionClick(e));
		});
		
		this.addBtn.addEventListener('click', () => this.addToCart());
  
		// Mobile Trigger
		const triggerBtn = this.closest('.product-card__media').querySelector('.conjunto-mobile-trigger');
		if (triggerBtn) {
		  triggerBtn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			const wrapper = this.closest('.conjunto-add-to-cart-wrapper');
			wrapper.classList.toggle('show');
		  });
		}
	  }
	  
	  handleOptionClick(e) {
		const btn = e.target;
		if (btn.classList.contains('disabled')) return;
		
		const itemId = btn.dataset.itemId;
		const variantId = btn.dataset.variantId;
		
		// Deselect siblings
		const container = btn.closest('.conjunto-item-options');
		container.querySelectorAll('.conjunto-option-btn').forEach(b => b.classList.remove('selected'));
		
		// Select clicked
		btn.classList.add('selected');
		this.selectedVariants[itemId] = variantId;
		
		this.checkCompletion();
	  }
	  
	  checkCompletion() {
		// Check if all items have a selection
		const totalItems = this.items.length;
		const selectedCount = Object.keys(this.selectedVariants).length;
		
		if (selectedCount === totalItems) {
		  this.addBtn.classList.add('visible');
		  this.addBtn.removeAttribute('disabled');
		} else {
		  this.addBtn.classList.remove('visible');
		  this.addBtn.setAttribute('disabled', 'true');
		}
	  }
  
	  handleError() {
		  this.addBtn.textContent = 'Erro';
		  setTimeout(() => {
			 this.addBtn.textContent = 'Adicionar ao carrinho';
			 this.addBtn.classList.remove('loading');
		  }, 2000);
	  }
	  
	  addToCart() {
		const items = Object.values(this.selectedVariants).map(id => ({
		  id: parseInt(id),
		  quantity: 1
		}));
		
		this.addBtn.classList.add('loading');
		this.addBtn.textContent = 'Adicionando...';
		
		const config = fetchConfig('javascript');
		config.headers['X-Requested-With'] = 'XMLHttpRequest';
		
		const sections = this.cartDrawer ? this.cartDrawer.getSectionsToRender().map((section) => section.id) : [];
		
		const body = {
			items: items,
			sections: sections,
			sections_url: window.location.pathname
		};
  
		config.body = JSON.stringify(body);
		
		if (this.cartDrawer) {
			this.cartDrawer.setActiveElement(document.activeElement);
		}
  
		const cartAddUrl = window.routes ? window.routes.cart_add_url : '/cart/add.js';
		
		fetch(cartAddUrl, config)
		  .then((response) => response.json())
		  .then((response) => {
			if (response.status) {
			  window.console.error(response.status);
			  this.handleError();
			  return;
			}
  
			if (this.cartDrawer) {
			   this.cartDrawer.handleAddedItem(response);
			}
			
			this.addBtn.textContent = 'Adicionado!';
			setTimeout(() => {
			  this.addBtn.textContent = 'Adicionar ao carrinho';
			  this.addBtn.classList.remove('loading');
			}, 2000);
		  })
		  .catch((error) => {
			window.console.error(error);
			this.handleError();
		  });
	  }
	}
	
	customElements.define('custom-conjunto-form', CustomConjuntoForm);
}

// oculta box com opções de bundle erradas
(function checkAndHideYmqBox() {
    function verify() {
        var labels = document.querySelectorAll('div#ymq-box .ymq_lable');
        if (labels.length > 0) {
            var foundTitle = false;
            labels.forEach(function(label) {
                if (label.textContent.trim() === "Title") {
                    foundTitle = true;
                }
            });
            if (foundTitle) {
                var ymqBox = document.querySelector('#ymq-box');
                if (ymqBox) {
                    ymqBox.style.display = 'none';
                }
            }
            return;
        }
        setTimeout(verify, 50);
    }
    verify();
})();

/* Imagens em .content-description: no WebKit (Safari/iOS) o pedido embutido às vezes falha mesmo com URL válida (abrir em nova aba funciona). Carrega via fetch→blob nessas plataformas; nos demais, fallback se error ou naturalWidth===0. */
(function fixContentDescriptionImages() {
	var rootSel = '.content-description';
	var ATTR_DONE = 'data-desc-img-fixed';

	function absUrl(url) {
		if (!url || typeof url !== 'string') return url;
		var t = url.trim();
		if (t.indexOf('//') === 0) return 'https:' + t;
		return t;
	}

	function fixSrcset(srcset) {
		if (!srcset || typeof srcset !== 'string') return srcset;
		return srcset.split(',').map(function (part) {
			var bits = part.trim().split(/\s+/);
			if (bits[0]) bits[0] = absUrl(bits[0]);
			return bits.join(' ');
		}).join(', ');
	}

	function pickUrlFromSrcset(srcset) {
		if (!srcset || typeof srcset !== 'string') return '';
		var first = srcset.split(',')[0];
		var u = first.trim().split(/\s+/)[0];
		return absUrl(u);
	}

	function fixPictureSources(root) {
		root.querySelectorAll('picture source[srcset]').forEach(function (source) {
			var ss = source.getAttribute('srcset');
			if (ss) source.setAttribute('srcset', fixSrcset(ss));
		});
	}

	function isProblemPlatform() {
		var ua = navigator.userAgent || '';
		if (/iPhone|iPad|iPod/i.test(ua)) return true;
		if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
		if (/Macintosh/i.test(ua) && /Safari/i.test(ua) && !/Chrome|Chromium|Edg|Firefox|FxiOS/i.test(ua)) return true;
		return false;
	}

	function stripCrossOrigin(img) {
		img.removeAttribute('crossorigin');
		img.crossOrigin = null;
	}

	function loadViaBlob(img, httpUrl, onAlways) {
		if (!httpUrl || httpUrl.indexOf('http') !== 0) {
			if (typeof onAlways === 'function') onAlways();
			return;
		}
		if (img.getAttribute(ATTR_DONE) === 'blob') return;
		img.setAttribute(ATTR_DONE, 'blob');
		stripCrossOrigin(img);
		fetch(httpUrl, { mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer-when-downgrade' })
			.then(function (r) {
				if (!r.ok) throw new Error('bad');
				return r.blob();
			})
			.then(function (blob) {
				var objectUrl = URL.createObjectURL(blob);
				var revokeLater = function () {
					setTimeout(function () {
						try {
							URL.revokeObjectURL(objectUrl);
						} catch (e) {}
					}, 120000);
				};
				img.addEventListener(
					'load',
					function () {
						revokeLater();
						if (typeof onAlways === 'function') onAlways();
					},
					{ once: true }
				);
				img.addEventListener(
					'error',
					function () {
						try {
							URL.revokeObjectURL(objectUrl);
						} catch (e) {}
						img.removeAttribute(ATTR_DONE);
						img.src = httpUrl;
						if (typeof onAlways === 'function') onAlways();
					},
					{ once: true }
				);
				img.src = objectUrl;
			})
			.catch(function () {
				img.removeAttribute(ATTR_DONE);
				img.src = httpUrl;
				if (typeof onAlways === 'function') onAlways();
			});
	}

	function wireBlobFallback(img, httpUrl) {
		if (!httpUrl || httpUrl.indexOf('http') !== 0) return;
		var tryBlob = function () {
			if (img.naturalWidth > 0) return;
			loadViaBlob(img, httpUrl);
		};
		img.addEventListener('error', tryBlob, { once: true });
		img.addEventListener('load', function () {
			requestAnimationFrame(function () {
				if (img.naturalWidth === 0 && img.complete) tryBlob();
			});
		});
	}

	function fixImg(img) {
		if (img.getAttribute(ATTR_DONE) === '1' || img.getAttribute(ATTR_DONE) === 'blob') return;

		var ds = img.getAttribute('data-src');
		var dss = img.getAttribute('data-srcset');
		var srcsetAttr = img.getAttribute('srcset');
		var httpUrl = '';

		if (ds) {
			httpUrl = absUrl(ds);
			img.removeAttribute('data-src');
			img.removeAttribute('data-srcset');
			img.removeAttribute('data-sizes');
		} else {
			httpUrl = absUrl(img.getAttribute('src') || '');
		}

		if (!httpUrl && srcsetAttr) httpUrl = pickUrlFromSrcset(srcsetAttr);
		if (!httpUrl && dss) httpUrl = pickUrlFromSrcset(dss);

		if (dss && !ds) {
			img.setAttribute('srcset', fixSrcset(dss));
			img.removeAttribute('data-srcset');
		} else if (srcsetAttr && !ds) {
			img.setAttribute('srcset', fixSrcset(srcsetAttr));
		}

		var dz = img.getAttribute('data-sizes');
		if (dz) {
			img.setAttribute('sizes', dz);
			img.removeAttribute('data-sizes');
		}

		stripCrossOrigin(img);
		img.loading = 'eager';
		img.setAttribute('loading', 'eager');
		img.classList.remove('lazyload', 'lazyloading');
		img.classList.add('lazyloaded');

		if (window.lazySizes && lazySizes.loader && typeof lazySizes.loader.unveil === 'function') {
			try {
				lazySizes.loader.unveil(img);
			} catch (e) {}
		}

		if (!httpUrl) return;

		if (isProblemPlatform()) {
			img.removeAttribute('srcset');
			img.removeAttribute('sizes');
			img.removeAttribute('src');
			loadViaBlob(img, httpUrl, function () {
				img.setAttribute(ATTR_DONE, '1');
			});
			return;
		}

		img.setAttribute('src', httpUrl);
		img.setAttribute(ATTR_DONE, '1');
		wireBlobFallback(img, httpUrl);
	}

	function run() {
		document.querySelectorAll(rootSel).forEach(function (block) {
			fixPictureSources(block);
			block.querySelectorAll('img').forEach(fixImg);
		});
	}

	function bindVerMaisRerun() {
		document.querySelectorAll(rootSel + ' .ver-mais--btn').forEach(function (btn) {
			btn.addEventListener('click', function () {
				setTimeout(run, 0);
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			run();
			bindVerMaisRerun();
		});
	} else {
		run();
		bindVerMaisRerun();
	}
})();

(function () {
	function hideEmptyTrustvoxRatings(root) {
		var scope = root && root.querySelectorAll ? root : document;
		if (root && root.matches && root.matches('.trustvox-shelf-container')) {
			markEmpty(root);
		}
		scope.querySelectorAll('.trustvox-shelf-container').forEach(markEmpty);
	}

	function markEmpty(container) {
		var countEl = container.querySelector('[itemprop="ratingCount"]');
		if (!countEl) return;
		var count = parseInt(String(countEl.textContent || '').replace(/\D/g, ''), 10);
		if (count === 0) {
			container.classList.add('is-empty-rating');
			container.style.visibility = 'hidden';
			var wrap = container.closest('.trustvox-widget-rating');
			if (wrap) wrap.style.visibility = 'hidden';
		}
	}

	function observe() {
		hideEmptyTrustvoxRatings(document);
		new MutationObserver(function (mutations) {
			for (var i = 0; i < mutations.length; i++) {
				var nodes = mutations[i].addedNodes;
				for (var j = 0; j < nodes.length; j++) {
					var node = nodes[j];
					if (node.nodeType !== 1) continue;
					if (
						node.matches &&
						(node.matches('.trustvox-shelf-container, .ts-shelf-container') ||
							node.querySelector('[itemprop="ratingCount"], .trustvox-shelf-container, .ts-shelf-container'))
					) {
						hideEmptyTrustvoxRatings(node);
					}
				}
			}
		}).observe(document.documentElement, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observe);
	} else {
		observe();
	}
})();

(function () {
	var SHOWN_KEY = 'kalini_gfb_164551_shown_at';
	var SUBMITTED_KEY = 'kalini_gfb_164551_submitted';
	var COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;
	var markedShown = false;

	function canShow() {
		try {
			if (localStorage.getItem(SUBMITTED_KEY) === '1') return false;
			var shownAt = parseInt(localStorage.getItem(SHOWN_KEY) || '', 10);
			if (shownAt && Date.now() - shownAt < COOLDOWN_MS) return false;
		} catch (e) {}
		return true;
	}

	if (canShow()) document.documentElement.classList.add('gfb-164551-allow');

	setInterval(function () {
		var root = document.getElementById('globo-formbuilder-164551');
		if (!root) return;

		var submitBtn = root.querySelector('.action.submit');
		if (submitBtn && !submitBtn.dataset.gfbBound) {
			submitBtn.dataset.gfbBound = '1';
			submitBtn.addEventListener('click', function () {
				try { localStorage.setItem(SUBMITTED_KEY, '1'); } catch (e) {}
			});
		}

		if (!markedShown && root.querySelector('.globo-form-app.active')) {
			markedShown = true;
			try { localStorage.setItem(SHOWN_KEY, String(Date.now())); } catch (e) {}
		}
	}, 500);
})();